import { arrayOf, shape, string } from "prop-types";

const selectOptions = arrayOf(
  shape({
    value: string.isRequired,
    label: string.isRequired
  })
);

export const groupedSelectOptions = arrayOf(
  shape({
    label: string.isRequired,
    options: selectOptions.isRequired
  })
);

export default selectOptions;
